import { SessionState } from "@/store/session/state";

/**
 * @param state - Vuex state for the session module.
 * @returns boolean.
 */
export function getIsSidebarCollapsed(state: SessionState): boolean {
  return state.isSidebarCollapsed;
}

/**
 * @param state - Vuex state for the session module.
 * @returns boolean.
 */
export function getSessionUrl(state: SessionState): string | undefined {
  return state.sessionUrl;
}

/**
 * @param state - Vuex state for the session module.
 * @returns encoded string for the state.
 */
export function getEncodedSessionObject(state: SessionState): string {
  return window.btoa(JSON.stringify(state));
}
